import { Loading } from 'react-admin';
import Loadable from 'react-loadable';

const FlavorList = Loadable({ loader: () => import('./flavorList'), loading: Loading });
const FlavorCreate = Loadable({ loader: () => import('./flavorCreate'), loading: Loading });
const FlavorEdit = Loadable({ loader: () => import('./flavorEdit'), loading: Loading });

export default { 
  list: FlavorList,
  create: FlavorCreate,
  edit: FlavorEdit
};